import { Colors, Icon } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import React, { ChangeEvent, useState } from "react";
import { styled } from "styled-components";

interface InputFieldProps {
  mt?: string;
  bradius?: string;
  pd?: string;
  label?: string;
  name: string;
  type: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  inputContainerClass?: string;
  placeholder?: string;
  disabled?: boolean;
}

const InputField: React.FC<InputFieldProps> = ({
  mt,
  bradius,
  pd,
  label,
  name,
  type,
  value,
  onChange,
  inputContainerClass,
  placeholder = "Please Input",
  disabled = false,
}) => {
  const isPasswordField = type === "password";
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className={inputContainerClass ?? "mt-xlg"}>
      {label && <Label htmlFor={name}>{label}</Label>}
      <InputWrapper>
        <CustomInputField
          mt={mt}
          bradius={bradius}
          pd={pd}
          name={name}
          type={isPasswordField && showPassword ? "text" : type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
        />
        {isPasswordField && (
          <PasswordToggleButton
            type="button"
            aria-label={showPassword ? "Hide password" : "Show password"}
            onClick={() => setShowPassword((prev) => !prev)}
          >
            <Icon
              icon={showPassword ? IconNames.EYE_OFF : IconNames.EYE_OPEN}
              color={Colors.GRAY2}
              size={16}
            />
          </PasswordToggleButton>
        )}
      </InputWrapper>
    </div>
  );
};

export default InputField;

const Label = styled.label`
    font-size: 15px;
    color: ${({ theme: { darkMode } }) =>darkMode ? Colors.GRAY5 : Colors.GRAY1};
`;

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const PasswordToggleButton = styled.button`
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  color: ${Colors.GRAY2};
  &:focus-visible {
    outline: none;
  }
`;

const CustomInputField = styled.input<{ mt?: string, bradius?: string, pd?: string, disabled?: boolean }>`
    width: 100%;
    background-color: ${({ theme: { darkMode } }) =>darkMode ? Colors.DARK_GRAY3 : Colors.LIGHT_GRAY5};
    border: 1px solid ${({ theme: { darkMode } }) =>darkMode ? Colors.GRAY1 : Colors.LIGHT_GRAY3};
    font-size: 15px;
    border-radius: ${({ bradius }) =>bradius ? bradius : "10px"};
    color: ${({ theme: { darkMode } }) =>darkMode ? Colors.GRAY4 : Colors.GRAY2};
    margin-top: ${({ mt }) =>mt ? mt : "3px"};
    padding: ${({ pd }) =>pd ? pd : "10px 15px"};
    cursor: ${({ disabled }) =>disabled ? "not-allowed" : "unset"};
    padding-right: 42px;
    &:focus-visible{
      outline: none;
    }
    &::placeholder{
      color: ${({ theme: { darkMode } }) =>darkMode ? Colors.GRAY1 : Colors.LIGHT_GRAY1};
    }
`;
